import { useState } from 'react'
const useRefreshTime = () => {
  const [refreshTime, setRefreshTime] = useState<any>('')
  return [refreshTime, setRefreshTime]
}

export default useRefreshTime
